var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotel = function SvgHotel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 22 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hotel_svg__a",
    d: "M22 17H2v-7h20v7zM7 9V7.5C7 6.673 7.673 6 8.5 6s1.5.673 1.5 1.5V9H7zm7 0V7.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V9h-3zM4 4h16v5h-2V7.5C18 6.121 16.879 5 15.5 5A2.502 2.502 0 0 0 13 7.5V9h-2V7.5C11 6.121 9.879 5 8.5 5A2.502 2.502 0 0 0 6 7.5V9H4V4zm18.5 5H21V3.5a.5.5 0 0 0-.5-.5h-17a.5.5 0 0 0-.5.5V9H1.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5H4v2.5a.5.5 0 0 0 1 0V18h14v2.5a.5.5 0 0 0 1 0V18h2.5a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hotel_svg__a",
    fillRule: "evenodd",
    transform: "translate(-1 -3)"
  })));
};
export default SvgHotel;